


















































































































/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import { PARKING_LOT_LIST } from '../router-names';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
import { IFieldInfoListItem } from '@root/types/component';
import moment from 'moment';
import { DEVICE_LIST, CHANNEL_LIST, GANG_STOP, AREA_LIST } from '../router-names';
// axios请求
import { queryParkingLot, getcommunityCode } from '@/api/parking-lot-management/index';
import { typesOperatorsMap, detailPropertyMap } from '@/types/parking-lot-management/dictionaries';
import { trim } from '@root/utils/validators';
import Utils from '@root/utils/common';
// import Utils from '@root/utils/common'
// import { dictoperationStateMap } from '@/types/parking-lot-management/dictionaries'
import * as _ from 'lodash';
import { API_SERVER } from '@root/common/config';
import { isChangcheng, isShiDaill, isShiDaisy } from '@root/utils/env';
@Component
export default class ParkingLotListDetail extends Mixins(GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/parking-lot-list/';

  headTitle = '车场详情'; // 当前标题
  parkId: string = '';
  parkListForm: any = {};
  // 运营类型 01：开发商委托 02：业委会委托 03：小业主委托
  typesOperators: any[] = Utils.toLabelVal(typesOperatorsMap);
  // 项目属性 01：酬金制 02：包干制
  // detailProperty: any[] = Utils.toLabelVal(detailPropertyMap)
  detailProperty: any[] = Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.project_attribute_type || {});
  isshidaill: boolean = isShiDaill;
  communityName: string = '';
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '车场信息',
        location: {
          name: PARKING_LOT_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  isChangcheng: boolean = isChangcheng;
  isSDShangYe: boolean = isShiDaisy;
  parkListFormhead = [
    {
      prop: 'projectName',
      label: '项目名称 ：'
    },
    {
      prop: 'projectCode',
      label: '项目编码 ：'
    },
    {
      prop: 'createTime',
      label: '创建时间 ：'
    },
    {
      prop: 'parkType',
      label: '车场业态 ：'
    },
    {
      prop: 'contacts',
      label: '联系人 ：'
    },
    {
      prop: 'deviceProvider',
      label: '边缘服务提供商 ：'
    },
    {
      prop: 'misVersion',
      label: '边缘版本号 ：'
    },
    {
      prop: 'connectStatus',
      label: '连接状态 ：'
    },
    {
      prop: 'phoneNumber',
      label: '联系电话 ：'
    }
  ];
  parkListFormtop = [
    {
      prop: 'plateNum',
      label: '总车位 ：'
    },
    {
      prop: 'fixedNum',
      label: '固定车位 ：'
    },
    {
      prop: 'tempNum',
      label: '临停车位 ：'
    },
    {
      prop: 'freeNum',
      label: '空闲车位 ：'
    }
  ];
  parkListForms = [
    {
      prop: 'areaNum',
      label: '区域个数 ：'
    },
    {
      prop: 'channelNum',
      label: '通道个数 ：'
    },
    {
      prop: 'deviceNum',
      label: '设备数量 ：'
    },
    {
      prop: 'sentryNum',
      label: '岗亭数量 ：'
    }
  ];

  parkListFormMis = [];

  parkListFormbottom = [
    {
      prop: 'areaName',
      label: '所属区域 ：'
    },
    {
      prop: 'address',
      label: '详情地址 ：'
    },
    {
      prop: 'businessId',
      label: '商圈ID ：'
    },
    // {
    //   prop: 'amapId',
    //   label: '高德地图唯一标识 ：',
    // },
    {
      prop: 'longitude',
      label: '经度 ：'
    },
    {
      prop: 'latitude',
      label: '维度 ：'
    }
  ];
  //通道列表页面
  toChannel() {
    this.$router.push({
      //path: '/smart-parking/parking-lot-management/channel-list',
      name: CHANNEL_LIST,
      params: { parkId: this.parkId }
    });
  }
  //去区域列表
  toArea() {
    this.$router.push({
      //path: '/smart-parking/parking-lot-management/area-list',
      name: AREA_LIST,
      params: { parkId: this.parkId }
    });
  }
  //去设备列表
  toDevice() {
    this.$router.push({
      //path: '/smart-parking/parking-lot-management/device-list',
      name: DEVICE_LIST,
      params: { parkId: this.parkId }
    });
  }
  //去岗亭列表
  toGangStop() {
    this.$router.push({
      //path: '/smart-parking/parking-lot-management/gang-stop',
      name: GANG_STOP,
      params: { parkId: this.parkId }
    });
  }
  // 生命周期初始化
  created() {
    this.parkId = this.$route.params.parkId;
    this.renderParkDetail(this.$route.params.parkId);
    if (this.isshidaill) {
      this.setcommunityCodeList();
    }
  }

  // 运营状态,多个逗号分隔   01：正式运营 02：试运营 03：已停用 04：未接入
  // operationStateOptions: IOption[] = Utils.toLabelVal(dictoperationStateMap)
  /**
   * 获取当前车场详情信息
   */
  async renderParkDetail(parkId: string) {
    try {
      const { status, code, msg, data } = await queryParkingLot({ parkId });
      if (status === '9999') {
        this.parkListForm = data;
        if (data.projectAttribute) {
          const projectList = _.filter(this.detailProperty, { value: data.projectAttribute });
          this.parkListForm.projectAttributeName = projectList.length > 0 ? projectList[0].label : '--';
        }
        if (data.operationType) {
          const operationList = _.filter(this.typesOperators, { value: data.operationType });
          this.parkListForm.operationTypeName = operationList.length > 0 ? operationList[0].label : '--';
        }
      }
    } catch (e) {
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  previewVisible: boolean = false;
  previewImage: string = '';
  API_SERVER = API_SERVER;
  // // 审核意见 00 通过 01
  handlePreviewCancel() {
    this.previewVisible = false;
  }
  async handlePreview(url: string) {
    this.previewImage = url;
    this.previewVisible = true;
  }
  // 获取社区代码
  async setcommunityCodeList() {
    try {
      const result = await getcommunityCode();
      const list = [result.data];
      this.getTreeData(list);
    } catch (e) {
      console.log(e);
    }
  }
  getTreeData(data) {
    for (var i = 0; i < data.length; i++) {
      if (this.parkListForm.communityCodeList.length > 0) {
        if (this.parkListForm.communityCodeList[0] === data[i].id) {
          this.communityName += data[i].name + '/';
          this.parkListForm.communityCodeList.splice(0, 1);
          if (data[i].sonAccountList) {
            this.getTreeData(data[i].sonAccountList);
          }
        }
      }
    }
  }
}
